import { useState } from "react";
import { Button } from "@/shared/components/shadcn/Button";
import { AmountInput } from "@/shared/components/ui/AmountInput";
import { Card } from "@/shared/components/ui/Card";
import { FullScreenDialog, type DialogDismissReason } from "@/shared/components/ui/FullScreenDialog";
import { formatMoney } from "@/shared/utils/formatters";

interface AppointmentDepositPickerProps {
  open: boolean;
  amount: number;
  price: number;
  currency: string;
  onApply: (amount: number) => void;
  onClose: (reason?: DialogDismissReason) => void;
}

function DepositEditor({ amount, price, currency, onApply, onClose }: Omit<AppointmentDepositPickerProps, "open">) {
  const [draft, setDraft] = useState(() => amount.toFixed(2));
  const numeric = Number(draft);
  const error = !/^(?:\d+(?:\.\d{1,2})?|\.\d{1,2})$/.test(draft) || !Number.isFinite(numeric) || !Number.isSafeInteger(Math.round(numeric * 100))
    ? "Enter a finite amount of zero or more with up to two decimal places."
    : numeric > price ? `Deposit cannot exceed ${formatMoney(price, currency)}.` : undefined;
  return (
    <FullScreenDialog narrowFooter title="Deposit amount" onClose={onClose} footer={<Button disabled={!!error} onClick={() => { if (!error) { onApply(numeric); onClose(); } }}>Apply deposit</Button>}>
      <div className="mx-auto max-w-[452px] space-y-2 p-4">
        <Card className="py-3"><div className="flex justify-between gap-2 text-sm"><span>Appointment price</span><strong>{formatMoney(price, currency)}</strong></div></Card>
        <AmountInput label={`Deposit amount (${currency})`} value={draft} onValueChange={setDraft} error={error}>
          <div className="grid grid-cols-5 gap-1.5">
            {[0, 10, 25, 50, 100].map((percent) => <Button key={percent} variant="secondary" onClick={() => setDraft((Math.round(price * percent) / 100).toFixed(2))}>{percent}%</Button>)}
          </div>
        </AmountInput>
      </div>
    </FullScreenDialog>
  );
}

export function AppointmentDepositPicker({ open, ...props }: AppointmentDepositPickerProps) {
  return open ? <DepositEditor {...props} /> : null;
}
